import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbHtml } from '../../types/pbBlocks';
import { getAdvanced, parseStyleString } from '../utils';

export type HtmlType = ContentTypeObject & PbHtml;

/**
 * Aggregates the configuration of a html element.
 * @param node
 */
export function htmlConfigAggregator(node: CustomHtmlElement): HtmlType {
    const style = parseStyleString(node.attributes.style);

    const isDecoded = node.attributes['data-decoded'] === 'true';

    return {
        ...getAdvanced(node, style),
        html: isDecoded ? node.innerHTML : node.textContent,
        uniqueID: node.attributes['data-pb-style'],
    };
}
